<template>
  <v-card flat style="background: transparent;">
    <v-card-text class="pa-0">
      <v-data-table
        style="background: transparent;"
        :footer-props="{ 'items-per-page-options': itemsPerPageOptions }"
        :headers="headers"
        :items="users"
        :search="search"
        :loading="loading"
        mobile-breakpoint=""
      >
        <template
          v-if="users.length"
          #body="{ items }"
        >
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td class="ma-0 pa-0">
                <v-list-item avatar>
                  <v-list-item-avatar>
                    <v-icon>account_box</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.usr }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </td>
              <td>
                <!-- <p>{{ item.acl }}</p> -->
                <template v-for="(perm, key) in getPartitionPermissions({acl: item.acl})">
                  <v-tooltip :key="`perm-${key}`" top>
                    <template #activator="{ on }">
                      <v-chip
                        v-on="on"
                        label
                        outlined
                        :color="perm.color"
                        class="mx-1 border-radius-0"
                      >
                        {{ key | upper }}
                      </v-chip>
                    </template>
                    <span>{{ perm.label }}</span>
                  </v-tooltip>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-else>
          <td
            v-if="loading"
          >
            {{ $t('searching') }}
          </td>

          <td
            v-else
          >
            {{ $t('$vuetify.noDataText') }}
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    search: {
      type: String,
      default: () => null
    }
  },
  created () {
    this.loadUsers()
  },
  data () {
    return {
      selectedUser: null,
      itemsPerPageOptions: [10, 20, 30, -1],
      loading: false,
      users: []
    }
  },
  computed: {
    headers () {
      const name = this.$tc('name', 2)

      return [
        {
          text: name,
          align: 'left',
          sortable: true,
          value: 'usr'
        },
        {
          text: 'Permissions',
          align: 'left',
          sortable: false,
          value: null
        }
      ]
    }
  },
  methods: {
    loadUsers () {
      const user = this.$store.state.auth.username
      this.loading = true
      this.$store.dispatch('user/getListUserTrusters', { user }).then(res => {
        this.users = res
        this.loading = false
      })
    },
    getPartitionPermissions ({ acl }) {
      const perm = this.$store.getters['acl/getPermissions']({ acl })
      const c = perm.canCreateObjects
      const r = perm.canListObjects
      const u = perm.canUpdateObjects
      const d = perm.canDeleteObjects

      return {
        c: {
          active: c,
          color: c ? 'blue' : 'grey',
          label: this.$t('perm.object_create')
        },
        r: {
          active: r,
          color: r ? 'blue' : 'grey',
          label: this.$t('perm.object_list')
        },
        u: {
          active: u,
          color: u ? 'blue' : 'grey',
          label: this.$t('perm.object_update')
        },
        d: {
          active: d,
          color: d ? 'blue' : 'grey',
          label: this.$t('perm.object_delete')
        }
      }
    }
  }
}
</script>
